import { isAndroid } from './isAndroid';

export const getLinkToMobileApp = () =>
  isAndroid() ? 'market://details?id=com.shoptagr' : 'https://itunes.apple.com/US/app/id1086670571';
